import GigsSectionPlaceholder from './GigsSectionPlaceholder';
import DeliveriesSectionPlaceholder from './DeliveriesSectionPlaceholder';

export default {
    GigsSectionPlaceholder,
    DeliveriesSectionPlaceholder,
};
